export default ".bold {\n  font-weight: bold;\n}"